function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEuLeaderLogo = function SvgEuLeaderLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 515 519"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 516.416,
    height: 519.517,
    x: 0.029,
    y: 1.134,
    ry: 0.696,
    style: {
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 1.1834048,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.698 2.308v45.29C183.821 45.46 121.396 104.88 92.734 203.927l29.423 7.305c26.147-90.463 86.315-134.638 177.277-137.334V442.07c116.575-1.737 149.305-66.387 179.483-132.951l24.274 9.496c-34.308 96.578-100.07 150.317-203.022 153.406l.736 46.752-300.855-.73L2.257 3.037l296.441-.73z",
    style: {
      opacity: 1,
      fill: "#005200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#005200",
      strokeWidth: "2.36680961px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.17 203.196-.736 19.723-74.295 70.129 33.102 41.638c14.043 21.207 11.74 45.683 13.24 69.398 1.097 17.696-.32 32.877-17.654 32.142-18.993.602-38.44-.606-59.221-7.159-36.618-12.902-88.69-42.328-106.458-76.788-12.806-33.973-15.665-78.465 22.24-95.756 25.645-10.348 48.253.558 71.352 8.035l30.894 19.724 58.112-56.25 29.423-24.836z",
    style: {
      opacity: 1,
      fill: "#ee0",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#ee0",
      strokeWidth: "2.36680961px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.807 297.43-12.505 19.724-70.616-44.56 27.217-3.653 55.904 28.49zm11.77 9.497-13.24 19.724 33.1 26.298 11.034 21.184 8.092-.73-2.943-19.724-16.918-28.49-19.125-18.262zM102.296 282.09l44.136 25.568 38.986 27.028 40.457 36.525 22.068 30.681 2.942 15.341-25.746 2.192-36.779-10.227-36.044-22.646-38.986-32.142-14.712-18.993-2.206-48.213 5.884-5.114z",
    style: {
      opacity: 1,
      fill: "#005200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#ee0",
      strokeWidth: "2.36680961px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.64 221.458 105.925-76.702-2.207-13.88-103.718 70.859v19.723zm12.477-82.697c16.125-15.807 34.736 12.45 21.475 26.139-11.541 1.564-30.645-15.368-21.475-26.139zm61.185-28.241c4.591 2.39 6.76 7.908 4.11 19.649-.003 16.33-24.048 10.998-23.544-3.31 2.43-12.01 6.846-20.386 19.434-16.339zm48.442-8.9c2.292-2.796 5.229-4.925 9.403-5.848 28.102 3.704 14.774 25.638-2.354 33.76-28.129 12.656-14.927-16.403-7.049-27.912zM411.61 155.4c10.83-2.458 12.979 4.936 12.773 15.004 6.98 21.279-18.674 16.324-26.492 3.247-6.15-10.198 4.456-16.134 13.72-18.252zm-38.382 59.787c-5.69 1.396-9.016-1.122-11.127-5.65-6.795-12.573-4.668-20.224 8.685-21.682 8.137 1.871 17.302 4.956 20.68 9.989 5.364 7.99-.026 18.355-18.238 17.343z",
    style: {
      opacity: 1,
      fill: "#005200",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#005200",
      strokeWidth: "2.36680961px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: -432.087,
    y: 45.52,
    style: {
      fontSize: "52.06980896px",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      textAlign: "start",
      lineHeight: "125%",
      writingMode: "lr-tb",
      textAnchor: "start",
      opacity: 1,
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#fff",
      strokeWidth: 1.1834048,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1,
      fontFamily: "Bitstream Vera Sans",
      InkscapeFontSpecification: "Bitstream Vera Sans"
    },
    transform: "matrix(0 -.99654 1.00347 0 0 0)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -432.087,
    y: 45.52,
    style: {
      fontSize: "62.72045135px",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      strokeWidth: 1.1834048,
      fontFamily: "Cortoba",
      InkscapeFontSpecification: "Cortoba"
    }
  }, "L E A D E R")));
};
export { SvgEuLeaderLogo as ReactComponent };
export default "data:image/svg+xml;base64,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";